import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/about',
    meta: {
        title: 'About the Project | Child Poverty',
    },
    title: 'About the Child Poverty Monitor',
    intro: oneLine`The Child Poverty Monitor reports on child poverty in Aotearoa <br class="hidden md+:inline" />
        New Zealand and its impacts.`,
    content: [
        oneLine`<p>The Child Poverty Monitor is a partnership project between the Office of the
            Children’s Commissioner, the JR McKenzie Trust and the New Zealand Child and
            Youth Epidemiology Service at the University of Otago.</p>`,
        oneLine`<p>In 2012, the Children’s Commissioner’s Expert Advisory Group on Solutions to
            Child Poverty put forward 78 recommendations on a range of ways to address
            child poverty.</p>`,
        oneLine`<p>One of those recommendations identified, was the need to measure and report on
            child poverty rates annually. We believe this is a vital step in reducing child
            poverty in Aotearoa New Zealand and that is why this project was born.</p>`,
        oneLine`<p>The measures of child poverty and its impacts use a variety of official data sources in Aotearoa New Zealand.</p>`,
        oneLine`<p>The data in the 2020 report mostly precedes the significant impact the COVID-19
            pandemic and the effects of the actions taken during lockdown and the ongoing
            management of the pandemic. Having pre-COVID-19 information on the status of
            poverty and wellbeing in Aotearoa New Zealand will assist with determining the impact in
            future years.</p>`,
    ],
};

export default data;
